import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Warning, Wrench, UserMinus, Clock } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmtEUR = (n) => `${Math.round(Number(n) || 0).toLocaleString('fr-FR')} EUR`;

export const EquipmentAlertsWidget = ({ wrapStyle }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/equipment/alerts`, { withCredentials: true });
      setData(res.data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (!data || !data.alerts || data.alerts.length === 0) return null;

  const { alerts, counts } = data;

  return (
    <div style={wrapStyle}>
      <div className="card" data-testid="equipment-alerts-widget">
        <div className="card-header" style={{ backgroundColor: '#FFEBEE' }}>
          <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#C62828' }}>
            <Warning size={20} weight="bold" /> Materiel a surveiller
          </h3>
        </div>
        <div style={{ padding: '16px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '14px' }}>
            <Kpi label="Alertes" value={counts.total} color="#C62828" icon={Warning} />
            <Kpi label="Ex-salaries" value={counts.ex_employee} color="#EF6C00" icon={UserMinus} />
            <Kpi label="Duree > 6 mois" value={counts.long_duration} color="#5E5F66" icon={Clock} />
          </div>
          <div style={{ padding: '8px 10px', backgroundColor: '#FFF3E0', borderRadius: '4px', marginBottom: '10px', fontSize: '0.8rem', color: '#E65100' }}>
            Valeur totale a risque : <strong>{fmtEUR(counts.value_at_risk)}</strong>
          </div>
          <div style={{ maxHeight: '260px', overflowY: 'auto' }}>
            <table className="data-table" style={{ fontSize: '0.82rem' }}>
              <thead>
                <tr>
                  <th>Materiel</th>
                  <th>Salarie</th>
                  <th style={{ textAlign: 'right' }}>Duree</th>
                  <th>Raison</th>
                </tr>
              </thead>
              <tbody>
                {alerts.slice(0, 10).map(a => (
                  <tr key={a.equipment_id} data-testid={`alert-row-${a.equipment_id}`}>
                    <td>
                      <div style={{ fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <Wrench size={12} /> {a.equipment_name}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: '#9E9E9E' }}>{a.category} - {fmtEUR(a.purchase_price)}</div>
                    </td>
                    <td>{a.user_name}{a.exit_date ? <div style={{ fontSize: '0.7rem', color: '#C62828' }}>Sorti le {a.exit_date}</div> : null}</td>
                    <td style={{ textAlign: 'right', fontWeight: '600' }}>{a.days_assigned != null ? `${a.days_assigned}j` : '-'}</td>
                    <td>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        {a.reasons.includes('ex_employee') && <span style={{ padding: '1px 6px', borderRadius: '3px', fontSize: '0.7rem', fontWeight: '600', backgroundColor: '#FFEBEE', color: '#C62828' }}>Ex-salarie</span>}
                        {a.reasons.includes('long_duration') && <span style={{ padding: '1px 6px', borderRadius: '3px', fontSize: '0.7rem', fontWeight: '600', backgroundColor: '#FFF3E0', color: '#EF6C00' }}>&gt; 6 mois</span>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {alerts.length > 10 && (
              <div style={{ textAlign: 'center', padding: '8px', fontSize: '0.75rem', color: '#5E5F66' }}>
                + {alerts.length - 10} autres alertes
              </div>
            )}
          </div>
          <button
            onClick={() => navigate('/resources?tab=materiel')}
            className="btn btn-secondary btn-sm"
            style={{ marginTop: '10px', width: '100%' }}
            data-testid="alerts-go-to-equipment"
          >
            Gerer le materiel
          </button>
        </div>
      </div>
    </div>
  );
};

const Kpi = ({ label, value, color, icon: Icon }) => (
  <div style={{ padding: '10px', backgroundColor: '#FAFAFA', border: '1px solid #E2E2E6', borderRadius: '6px', textAlign: 'center' }}>
    <div style={{ fontSize: '0.7rem', color: '#5E5F66', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginBottom: '2px' }}>
      {Icon && <Icon size={12} />} {label}
    </div>
    <div style={{ fontSize: '1.4rem', fontWeight: '700', color }}>{value}</div>
  </div>
);
